import React, { useState } from "react";
import IndicatorView from "./IndicateurView";


export interface IndicatorBlock {
  meta: {
    id: number;
    nom: string;
  };
  rows: Record<string, any>[];
}

interface Props {
  indicatorData: Record<number, IndicatorBlock>;
}

const IndicatorsTableContainer: React.FC<Props> = ({ indicatorData }) => {
  const indicators = Object.values(indicatorData);
  const [index, setIndex] = useState(0);

  if (indicators.length === 0) {
    return <p>Aucune donnée disponible</p>;
  }

  const current = indicators[index];

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 15,
        }}
      >
        <button
          className="btn btn-sm btn-secondary"
          disabled={index === 0}
          onClick={() => setIndex((i) => i - 1)}
        >
          ◀
        </button>

        <span>
          {index + 1} / {indicators.length}
        </span>

        <button
          className="btn btn-sm btn-secondary"
          disabled={index === indicators.length - 1}
          onClick={() => setIndex((i) => i + 1)}
        >
          ▶
        </button>
      </div>

      <IndicatorView meta={current.meta} rows={current.rows} />
    </div>
  );
};

export default IndicatorsTableContainer;